import React from 'react'

const PopularAmenitiesMegaMenu = ({ linkData }) => {
  return (
    <div className="flex w-inherit">
      <div className="flex-1">
        <div className="py-4 font-semibold uppercase leading-9 text-gray-800">
          <p>Treatment Setting</p>
        </div>
        <div className="flex gap-6">
          <div>
            <div className="mb-4 font-semibold text-gray-900">
              <p>Amenities</p>
            </div>
            <div className="mb-6 flex max-w-[440px] flex-wrap gap-y-2">
              {linkData.items.map((populars) => {
                const IconComponent = populars.image
                return (
                  <a
                    href={populars.link}
                    key={populars.name}
                    className="group flex w-[220px] items-center rounded-lg p-4 hover:bg-gray-100"
                  >
                    <IconComponent customCss="h-6 w-6 mr-2.5" />
                    <p className="text-sm !text-gray-700 group-hover:!text-gray-1100">
                      {populars.name}
                    </p>
                  </a>
                )
              })}
            </div>
          </div>
          <div>
            <div className="mb-4 font-semibold text-gray-900">
              <p>Settings</p>
            </div>
            <div className="mb-6 flex flex-col flex-wrap gap-y-2">
              {linkData.settings.map((setting) => (
                <a
                  href={setting.link}
                  key={setting.name}
                  className="my-0.5 w-[200px] py-4 text-sm !text-gray-700 hover:!text-gray-1100"
                >
                  {setting.name}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PopularAmenitiesMegaMenu
